import styled from 'astroturf/react';
import { Body } from 'js/design_system/Body';
import { Heading } from 'js/design_system/Heading';

export const TitleText = styled(Heading).attrs({
  size: 'md',
  fontFamily: 'serif',
  as: 'p' as any,
})`
  color: var(--text-primary, #141413);
  text-align: center;
  padding-bottom: 16px;
`;

export const BodyText = styled(Body).attrs({
  size: 'xl',
  fontFamily: 'sans-serif',
})`
  color: var(--text-primary, #141413);
  text-align: center;
`;

export const BodyTextSmall = styled(Body).attrs({
  size: 'sm',
  fontFamily: 'sans-serif',
})`
  color: var(--text-primary, #141413);
  text-align: center;
`;
